import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { newbuildingStatusChange } from '../../actions';
import { Projects } from '../../components/ProjectsRedesigned';
import { Tabs } from '../../components/tabs';
import { ViewModeSwitch } from '../../components/ViewModeSwitch';
import { getFilters, getNewbuildingsCounts } from '../../selectors';
import { Filters } from '../Filters';
import { ProjectsListRedesigned } from '../ProjectsList';

import { getTabs } from './helpers';
import { TViewMode } from './types';
import { TThunkDispatch } from '../../types/redux/thunk';
import { ENewbuildingStatus } from '../../types/filters';
import { Title } from '../../components/ProjectsTitle';

export function ProjectsRedesigned() {
  const [mode, setMode] = React.useState<TViewMode>('table');
  const dispatch: TThunkDispatch = useDispatch();
  const filters = useSelector(getFilters);
  const counts = useSelector(getNewbuildingsCounts);
  const tabs = React.useMemo(() => getTabs(counts), [counts]);

  const handleTabChange = React.useCallback(
    (newTab: ENewbuildingStatus) => {
      dispatch(newbuildingStatusChange(newTab));
    },
    [dispatch],
  );

  return (
    <Projects
      title={<Title />}
      tabs={<Tabs tabs={tabs} activeTab={filters.newbuildingStatus} onChange={handleTabChange} />}
      viewMode={<ViewModeSwitch mode={mode} onModeChange={setMode} />}
      filters={<Filters />}
      content={<ProjectsListRedesigned mode={mode} />}
    />
  );
}
